module.exports = __webpack_public_path__ + "img/logo.8186aa5a.png";